import { render, staticRenderFns } from "./wxyuceReport-ycd.vue?vue&type=template&id=61932078"
import script from "./wxyuceReport-ycd.vue?vue&type=script&lang=js"
export * from "./wxyuceReport-ycd.vue?vue&type=script&lang=js"
import style0 from "./wxyuceReport-ycd.vue?vue&type=style&index=0&id=61932078&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports